import { render, staticRenderFns } from "./DraggableBg.vue?vue&type=template&id=f8f4b826&scoped=true&"
import script from "./DraggableBg.vue?vue&type=script&lang=ts&"
export * from "./DraggableBg.vue?vue&type=script&lang=ts&"
import style0 from "./DraggableBg.vue?vue&type=style&index=0&id=f8f4b826&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8f4b826",
  null
  
)

export default component.exports